/*
 * vms-standard-actions.js
 * ---------------------------------------------------------------------------
 * [TRADE 16 PORT 2026-09-23 item 5] Our configuration of Shopify's Standard
 * Actions updateCart (window.Shopify.actions.updateCart), the call an app or an
 * AI agent makes to change the cart without knowing how this theme renders it.
 * Adapted from Dawn 15.5 assets/standard-actions-override.js, NOT a copy of it.
 *
 * WHY THE BUILT-IN REFRESH IS NOT ENOUGH FOR THIS CART. The platform bundle
 * (cdn.shopify.com/storefront/standard-actions.js) ships a default refresh that
 * is statement for statement the Dawn 15.5 override, and on our forked cart it
 * leaves the page wrong until the next load. Measured on DEV 2026-09-23
 * (reports/dawn-16-upgrade-review-2026-09-23/item5-standard-actions-test/TEST.md):
 *   - GET /cart.js?sections=... returns NO sections key, so the header
 *     #cart-icon-bubble count is never refreshed and the /cart subtotal stays
 *     stale.
 *   - The drawer subscriber (CartDrawerItems.onCartUpdate in assets/cart.js)
 *     replaces only cart-drawer-items and .cart-drawer__footer. It never removes
 *     is-empty from cart-drawer, so a cart that was empty at load shows "Your
 *     cart is empty" (631 px) over a 0 px tall row after an add.
 *   - THE RESERVE GATE (33FD001, custom.backorder_enabled) lives in .cart__ctas
 *     in the drawer and in .cart__blocks of main-cart-footer on /cart, outside
 *     everything the default refreshes. An add left a live, ENABLED checkout
 *     button; a removal left a stale notice blocking a clean cart. The theme is
 *     the only enforcement layer for reserve mode (README, 2026-09-09 rule).
 *
 * WHAT THIS FILE DOES. updateCart runs Shopify's default handler first (the
 * Storefront API mutation and the standard shopify:cart:* events, whose result
 * is returned unchanged apart from a detail marker), then refreshes in place
 * from ONE Section Rendering API GET on the cart URL (routes.cart_url, never
 * /cart.js) plus /cart.js for the Ajax cart:
 *   1. the whole #CartDrawer .drawer__inner (rows, empty state, subtotal and
 *      the .cart__ctas reserve gate together), exactly the region the shopper
 *      path in cart.js (CartDrawerItems.getSectionsToRender) repaints;
 *   2. on /cart: #main-cart-items .js-contents and BOTH main-cart-footer
 *      regions (.js-contents and .cart__blocks, the 2026-09-09 reserve entry),
 *      the same entries CartItems.getSectionsToRender repaints;
 *   3. #cart-icon-bubble from the cart-icon-bubble section;
 *   4. is-empty on cart-drawer, cart-items and #main-cart-footer from
 *      item_count. This is the syncEmptyState rule of assets/vms-cart-grouping.js
 *      (the same three toggles Dawn's updateQuantity does). That function lives
 *      inside that file's IIFE and is not reachable from here, so the rule is
 *      restated in vmsSaIsEmpty / applyEmptyState below; change both together;
 *   5. publishes the theme pubsub cart-update with source 'cart-items' and the
 *      full Ajax cartData, exactly as a shopper action does, so CartItems and
 *      CartDrawerItems skip a second round trip while product-info,
 *      price-per-item, quick-add-bulk and quick-order-list still hear it.
 * If any step throws, or any planned region cannot be painted, the page does a
 * full window.location.reload(), which is always correct if blunt.
 * openCart keeps the platform default (it opens our cart-drawer in place,
 * measured); with is-empty now correct it needs no change.
 *
 * DOM HOOKS, each verified against our markup:
 *   cart-drawer (element), #CartDrawer, .drawer__inner, .drawer__inner-empty
 *       snippets/cart-drawer.liquid (rendered by sections/cart-drawer.liquid,
 *       so section id "cart-drawer" returns it)
 *   #cart-icon-bubble
 *       sections/vms-mega-header.liquid and sections/header.liquid; content
 *       from section id "cart-icon-bubble" (sections/cart-icon-bubble.liquid),
 *       painted into the anchor the way cart.js does (.shopify-section source)
 *   cart-items (element), #main-cart-items[data-id] .js-contents
 *       sections/main-cart-items.liquid
 *   #main-cart-footer[data-id] .js-contents and .cart__blocks
 *       sections/main-cart-footer.liquid
 *
 * THE CONTRACT KEPT. No cart markup, cart.js, cart-drawer.js or
 * vms-cart-grouping.js change: the painted regions and the event are the ones
 * the shopper path already produces, so the group stepper, "Remove this build",
 * the _vms_* line properties (an app contract) and the reserve gate Liquid all
 * behave as after a shopper edit. Guards: no window.Shopify.actions, no
 * updateCart.configure, or a configure call another script already won
 * (configure returns false) means this file does nothing and logs nothing.
 * window.VMSStandardActions records what happened, for tests and agents.
 */
(function () {
  'use strict';

  if (window.VMSStandardActions) return;
  var state = { version: '2026-09-23', configured: false, actionsAtLoad: false, refreshes: 0, reloads: 0 };
  window.VMSStandardActions = state;

  // ---- pure helpers (lifted by scripts/test_vms_standard_actions.js) --------

  // Every region we repaint. section: the Section Rendering id, or 'data-id'
  // to read it from the mount element's data-id (template section ids).
  // mountSelector null = the element with mountId itself.
  function vmsSaSelectorTable() {
    return [
      { key: 'drawer', section: 'cart-drawer', mountId: 'CartDrawer', mountSelector: '.drawer__inner', sourceSelector: '.drawer__inner' },
      { key: 'bubble', section: 'cart-icon-bubble', mountId: 'cart-icon-bubble', mountSelector: '.shopify-section', mountFallback: true, sourceSelector: '.shopify-section' },
      { key: 'items', section: 'data-id', mountId: 'main-cart-items', mountSelector: '.js-contents', sourceSelector: '.js-contents' },
      { key: 'footer-subtotal', section: 'data-id', mountId: 'main-cart-footer', mountSelector: '.js-contents', sourceSelector: '.js-contents' },
      { key: 'footer-blocks', section: 'data-id', mountId: 'main-cart-footer', mountSelector: '.cart__blocks', sourceSelector: '.cart__blocks' }
    ];
  }

  // probe.hasRoot(id), probe.hasMount(id, selector), probe.dataId(id).
  // Keeps only the entries whose mount is on this page, and lists each section
  // id once (the Section Rendering API takes at most 5; this table needs 4).
  function vmsSaBuildPlan(table, probe) {
    var entries = [];
    var sections = [];
    for (var i = 0; i < table.length; i++) {
      var t = table[i];
      if (!probe.hasRoot(t.mountId)) continue;
      var sectionId = t.section === 'data-id' ? probe.dataId(t.mountId) : t.section;
      if (!sectionId) continue;
      var hasMount = t.mountSelector ? probe.hasMount(t.mountId, t.mountSelector) : true;
      if (!hasMount && !t.mountFallback) continue;
      entries.push({
        key: t.key,
        section: sectionId,
        mountId: t.mountId,
        mountSelector: hasMount ? t.mountSelector : null,
        sourceSelector: t.sourceSelector
      });
      if (sections.indexOf(sectionId) === -1) sections.push(sectionId);
    }
    return { entries: entries, sections: sections };
  }

  function vmsSaSectionsUrl(cartUrl, sections) {
    var base = cartUrl || '/cart';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'sections=' + sections.map(encodeURIComponent).join(',');
  }

  // true / false from the Ajax cart item_count; null when it cannot be told,
  // in which case no is-empty class is touched.
  function vmsSaIsEmpty(cartData) {
    if (!cartData || typeof cartData.item_count !== 'number' || !isFinite(cartData.item_count)) return null;
    return cartData.item_count === 0;
  }

  // Reload when the refresh threw, the Ajax cart did not come back, or any
  // planned region was not painted (a half-painted cart is how a stale
  // checkout button survives). A superseded refresh (a newer call is already
  // painting) never reloads.
  function vmsSaShouldReload(outcome) {
    if (!outcome) return true;
    if (outcome.superseded) return false;
    if (outcome.threw) return true;
    if (!outcome.cartOk) return true;
    return outcome.painted !== outcome.planned;
  }

  // ---- DOM side --------------------------------------------------------------

  var domProbe = {
    hasRoot: function (id) {
      return !!document.getElementById(id);
    },
    hasMount: function (id, selector) {
      var root = document.getElementById(id);
      return !!(root && root.querySelector(selector));
    },
    dataId: function (id) {
      var root = document.getElementById(id);
      return (root && root.dataset && root.dataset.id) || null;
    }
  };

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  // NO Accept header on purpose. Measured on DEV 2026-09-23: GET
  // /cart?sections=... sent with Accept: application/json answers the Ajax
  // cart (token, items, item_count) and drops every section, exactly like
  // /cart.js?sections=; without the header it answers the sections map.
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('vms-standard-actions: ' + url + ' answered ' + res.status);
      return res.json();
    });
  }

  function paint(entry, html) {
    if (typeof html !== 'string') return false;
    var root = document.getElementById(entry.mountId);
    if (!root) return false;
    var mount = entry.mountSelector ? root.querySelector(entry.mountSelector) : root;
    if (!mount) return false;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector(entry.sourceSelector);
    if (!source) return false;
    mount.innerHTML = source.innerHTML;
    return true;
  }

  // The syncEmptyState rule from assets/vms-cart-grouping.js, restated.
  function applyEmptyState(isEmpty) {
    if (isEmpty === null) return;
    document.querySelectorAll('cart-items').forEach(function (el) {
      el.classList.toggle('is-empty', isEmpty);
    });
    var footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', isEmpty);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', isEmpty);
  }

  // Focus dies with the innerHTML that held it. If the drawer is open, trap
  // it again the way CartDrawer.open() does.
  function refocusOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active') || typeof trapFocus !== 'function') return;
    var container = drawer.classList.contains('is-empty')
      ? drawer.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    var focusEl = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
    if (container && focusEl) trapFocus(container, focusEl);
  }

  function publishCartUpdate(cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cartData });
    }
  }

  var refreshSeq = 0;

  function refreshCartUI() {
    var seq = ++refreshSeq;
    var plan = vmsSaBuildPlan(vmsSaSelectorTable(), domProbe);
    var sectionsReq = plan.sections.length ? getJSON(vmsSaSectionsUrl(cartUrl(), plan.sections)) : Promise.resolve({});
    var cartReq = getJSON(cartUrl() + '.js');
    return Promise.all([sectionsReq, cartReq]).then(function (res) {
      if (seq !== refreshSeq) return { superseded: true };
      var rendered = res[0] || {};
      var cartData = res[1];
      var painted = 0;
      plan.entries.forEach(function (entry) {
        if (paint(entry, rendered[entry.section])) painted += 1;
      });
      var cartOk = !!(cartData && Array.isArray(cartData.items));
      applyEmptyState(vmsSaIsEmpty(cartData));
      refocusOpenDrawer();
      // quick-add-bulk.js reads cartData.items unconditionally, so a missing
      // cart is never published; the reload that follows repaints everything.
      if (cartOk) publishCartUpdate(cartData);
      state.refreshes += 1;
      return { cartOk: cartOk, planned: plan.entries.length, painted: painted };
    });
  }

  function reload() {
    state.reloads += 1;
    window.location.reload();
  }

  function init() {
    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.updateCart || typeof actions.updateCart.configure !== 'function') return;
    var took = actions.updateCart.configure({
      // Required for updateCart. Our theme listens on pubsub, not on the
      // shopify:cart:* events, so document is the conventional root.
      eventTarget: function () {
        return document;
      },
      handler: function (defaultHandler) {
        // A rejected default (network, malformed payload) propagates to the
        // caller untouched: the action could not run, nothing to repaint.
        return defaultHandler().then(function (result) {
          return refreshCartUI()
            .then(null, function () {
              return { threw: true };
            })
            .then(function (outcome) {
              if (vmsSaShouldReload(outcome)) reload();
              if (result && typeof result === 'object' && !result.detail) {
                result.detail = { renderedBy: 'vms-standard-actions' };
              }
              return result;
            });
        });
      }
    });
    state.configured = took !== false;
  }

  // Run now if the bundle has already attached Shopify.actions; otherwise wait
  // for DOMContentLoaded, which fires after every deferred and module script
  // (the bundle included). Loaded above content_for_header, this listener is
  // registered before any app's, so our configure call is the first one.
  if (window.Shopify && window.Shopify.actions) {
    state.actionsAtLoad = true;
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
